var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cc-facebook__tab"},[_c('AdName'),_c('Identity'),_c('AdSetup'),_c('AdCreative',{key:_vm.getAdBuildId}),_c('Destination'),_c('Tracking')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }